import { OnInit, Component, OnDestroy, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { filter, take, takeUntil, tap } from "rxjs/operators";

import { AnnouncementsActions } from "../../shared/state/actions/data/action-creators/announcements.action";
import {
	selectAllAnnouncements,
	selectLatestUnreadAnnouncement,
} from "../../shared/state/selectors/announcements.selectors";

@Component({
	templateUrl: "announcements.component.html",
	styleUrls: ["announcements.component.scss"],
	standalone: false,
})
export class AnnouncementsComponent implements OnInit, OnDestroy {
	private readonly store = inject(Store);

	announcements$ = this.store.select(selectAllAnnouncements).pipe(take(1));
	private readonly destroy$ = new Subject<void>();

	ngOnInit(): void {
		this.store
			.select(selectLatestUnreadAnnouncement)
			.pipe(
				take(1),
				filter((announcement) => !!announcement),
				tap((announcement) =>
					this.store.dispatch(AnnouncementsActions.setAnnouncementRead({ version: announcement.version })),
				),
				takeUntil(this.destroy$),
			)
			.subscribe();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
